import { render } from "./CardImage.vue?vue&type=template&id=70a9072a"
import script from "./CardImage.vue?vue&type=script&lang=js"
export * from "./CardImage.vue?vue&type=script&lang=js"

import "./CardImage.vue?vue&type=style&index=0&id=70a9072a&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__